import styled from 'styled-components'

export const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-weight: medium;
`;